import { ReactNode } from 'react';
import { ThemeProvider } from "../providers/ThemeProvider";
import { ModalProvider } from "./overlays/ModalManager";

interface ClientProvidersProps {
  children: ReactNode;
}

export default function ClientProviders({ children }: ClientProvidersProps) {
  return (
    <ThemeProvider>
      <ModalProvider>
        {children}
      </ModalProvider>
    </ThemeProvider>
  );
}
